import React from 'react'
import { connect } from 'react-redux' 
import { Redirect } from 'react-router-dom'
import {
  setDisplayName,
  branch,
  renderComponent,
  compose
} from 'recompose'
import { getIsLoggedIn } from 'Features/user/selectors'

const RedirectToLogin = () => <Redirect to='/login' />
const withAuthCheck = WrappedComponent => props => (
  <WrappedComponent {...props} />
)

export default WrappedComponent => compose(
  setDisplayName('withAuthCheck'),
  connect(
    state => ({
        isLoggedIn: getIsLoggedIn(state)
    })
  ),
  branch(
    ({ isLoggedIn }) => isLoggedIn,
    withAuthCheck,
    renderComponent(RedirectToLogin)
  )
)(WrappedComponent)


// WEBPACK FOOTER //
// ./src/front/lib/withAuthCheck.js